/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon/Icon';
import { useUser } from '../../hooks/UNSAFE_useUser';

type Props = Omit<ComponentProps<typeof Icon>, 'viewBox'>;

// Returns a component that renders one of the given icon components based on reading direction
export const withDirectionIcon = (LtrIcon: typeof Icon, RtlIcon: typeof Icon) => {
  return (props: Props) => {
    const { direction } = useUser();
    return direction === 'ltr' ? <LtrIcon {...props} /> : <RtlIcon {...props} />;
  };
};
